import React, { useState } from 'react';
import {
    useDispatch,
    useSelector
} from 'react-redux';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import {Navigate, Outlet} from 'react-router-dom'
import {
    setUserAuthd,
    selectAuth
} from '../features/home/homeSlice';

const isLoggedIn = () => {
    const user = localStorage.getItem('loggedIn');
    if(user){
        return true
    }else{
        return false
    }
}

const ProtectedRoute = () => {
    //const auth = isLoggedIn();
    const [auth, setAuth] = useState(useSelector(selectAuth));
    //const [auth, setAuth] = useState(isLoggedIn());
    //setAuth(localStorage.getItem('loggedIn'))
    //setAuth(isLoggedIn())
    console.log(`re rendering the protected route: ${localStorage.getItem('loggedIn')}`)

    return auth ? <Outlet/> : <Navigate to="/auth/login" />
}

export default ProtectedRoute
